import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import dialogDrag from '@/utils/dialogDrag'
import { permission, role } from '@/directives/permission'
import { hasPermission, hasRole, isSuperAdmin } from '@/utils/auth'

Vue.use(ElementUI)
Vue.directive('dialog-drag', dialogDrag)
Vue.directive('permission', permission)
Vue.directive('role', role)

// 模板中可直接用 this.$hasPermission / $hasRole
Vue.prototype.$hasPermission = hasPermission
Vue.prototype.$hasRole = hasRole
Vue.prototype.$isSuperAdmin = isSuperAdmin

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
